import SwiperCore, { Navigation, EffectFade, Autoplay } from "swiper/core";
import "swiper/swiper-bundle.css";

// configure Swiper to use modules
SwiperCore.use([Navigation, EffectFade, Autoplay]);

export default function initCarousel() {
    const carousel = new SwiperCore(".swiper-container", {
        speed: 1500,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    return carousel;
}
